import { Injectable } from '@angular/core';

import { AbstractEventPlugin } from './abstract.plugin';

@Injectable({
  providedIn: 'root',
})
export class PreventEventPlugin extends AbstractEventPlugin {
  protected readonly modifier = '.prevent';

  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  public override addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
    return this.manager.addEventListener(element, this.unwrap(eventName), (event: Event): void => {
      event.preventDefault();
      handler(event);
    });
  }
}
